import React, { useState, useEffect } from 'react';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';

import { Shimmer } from '..';

import { ReactComponent as ArrowUp } from '../../assets/icons/ubr_arrow_up.svg';
import { useAuth } from '../../hooks/useAuth';
import Button from '../Button';
import {
  FooterPage,
  Container,
  FooterIcon,
  Divider,
  FooterContent,
} from './styles';

type QuickAccessScreen = {
  id: string | number;
  url: string;
  titulo: string;
};

function resolveQuickAccessScreens(userTelas: unknown): QuickAccessScreen[] {
  if (!Array.isArray(userTelas)) {
    return [];
  }
  return userTelas as QuickAccessScreen[];
}

export const Footer: React.FC = () => {
  const [pathLocation, setPathLocation] = useState<string>('');
  const location = useLocation();
  const { user } = useAuth();
  const quickAccessScreens = resolveQuickAccessScreens(user?.telas);
  const hasQuickAccessScreens = quickAccessScreens.length > 0;
  useEffect(() => {
    setPathLocation(location.pathname);
  }, [location.pathname]);

  return (
    <>
      {pathLocation === '/home' ? null : (
        <FooterPage>
          <Container>
            <div>
              {hasQuickAccessScreens ? (
                <>
                  <h3>ACESSO RÁPIDO</h3>
                  {quickAccessScreens.map(tela => (
                    <ul key={tela.id}>
                      <Link to={tela.url}>
                        <FooterIcon>
                          <RiArrowDropRightLine size={20} />
                        </FooterIcon>
                        <li>{tela.titulo}</li>
                      </Link>
                    </ul>
                  ))}
                </>
              ) : (
                <>
                  <Shimmer width={'325px'} height={'25px'} />
                  <Shimmer width={'225px'} height={'25px'} />
                  <Shimmer width={'225px'} height={'25px'} />
                  <Shimmer width={'225px'} height={'25px'} />
                </>
              )}
            </div>
            <Divider />
            <FooterContent>
              {user ? (
                <p>Todos os Direitos Reservados</p>
              ) : (
                <Shimmer width={'225px'} height={'25px'} />
              )}

              <LinkScroll
                to="headerPage"
                spy={true}
                smooth={'easeInOutQuart'}
                offset={-70}
                duration={1000}
              >
                <Button variant={'solid-icon'} color={'rgb(228, 228, 228)'}>
                  <ArrowUp width={24} style={{ color: '#166649' }} />
                </Button>
              </LinkScroll>
            </FooterContent>
          </Container>
        </FooterPage>
      )}
    </>
  );
};
